module.exports = __webpack_public_path__ + "img/qr.bb1d2291.png";